<global-breadcrumbs
  [dynamicRoute]="{ url: '/dashboard', label: 'dashboard.title' }"
  [alignCenterTitle]="true">
</global-breadcrumbs>
<pac-account-tariff
  (accountCreated)="goToDashboard($event)"
  [selectedServer]="selectedServer">
</pac-account-tariff>